import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

// Slim summer announcement bar. Shown only when the seasonal theme is active
// and the banner is enabled in the Website Builder. Purely visual, single language.
export const SeasonalBanner = () => {
  const { settings, seasonalActive } = useSettings();
  const s = settings.seasonal || {};

  if (!seasonalActive || !s.banner_enabled || !(s.banner_text || "").trim()) return null;

  const inner = (
    <div className="flex h-full items-center justify-center gap-2 px-4 text-center">
      <span className="text-sm font-medium tracking-tight text-white drop-shadow-sm">
        {s.banner_text}
      </span>
      {s.banner_link ? <ArrowRight strokeWidth={2} className="w-4 h-4 text-white/90" /> : null}
    </div>
  );

  return (
    <div
      data-testid="seasonal-banner"
      className="fixed top-0 inset-x-0 z-[60] h-10"
      style={{
        background: "linear-gradient(90deg, #FDB813 0%, #F7941E 45%, #FF7A59 100%)",
      }}
    >
      {s.banner_link ? (
        <Link to={s.banner_link} data-testid="seasonal-banner-link" className="block h-full hover:brightness-105 transition-all duration-200">
          {inner}
        </Link>
      ) : (
        inner
      )}
    </div>
  );
};
